export const QUOTATION = 'QUOTATION';
export const Quotation_LOGS = 'LOGS';
export const quotationTags = ['Quotation'];
